import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import CmsImage from "src/components/images/CmsImage";
import type { CinemaListItem } from "src/components/biografer/CinemaList";
import styles from "./Biograf.module.css";
import RightArrowSvg from "src/components/svg/RightArrowSvg";
function getAddress(contactText?: string) {
  if (!contactText) return undefined;
  const lines = contactText.split('\n');
  return [lines[1], lines[2]].filter(Boolean).join(' ') || undefined;
}
export default function Biograf(t0) {
  const $ = _c(20);
  const {
    cinema
  } = t0;
  let t1;
  if ($[0] !== cinema.contactText) {
    t1 = getAddress(cinema.contactText);
    $[0] = cinema.contactText;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const address = t1;
  const t2 = `/biografer/${cinema.slug.current}`;
  const t3 = `Les mer om ${cinema.title}`;
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = <Link href={t2} className={styles.cinemaFullLink} aria-label={t3} />;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = cinema.imageV2?.asset?.altText ?? cinema.imageV2?.asset?.title ?? cinema.title;
  let t6;
  if ($[5] !== cinema.imageV2 || $[6] !== t5) {
    t6 = <div className={styles.cinemaThumbWrapper}><CmsImage className={styles.cinemaThumb} image={cinema.imageV2} alt={t5} width={72} height={72} sizes="72px" crop={true} /></div>;
    $[5] = cinema.imageV2;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== cinema.title) {
    t7 = <span className={styles.cinemaTitle}>{cinema.title}</span>;
    $[8] = cinema.title;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== address) {
    t8 = address && <span className={styles.cinemaAddress}>{address}</span>;
    $[10] = address;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7 || $[13] !== t8) {
    t9 = <div className={styles.cinemaInfo}>{t7}{t8}</div>;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span className={styles.cinemaLink} aria-hidden="true"><span className={styles.cinemaLinkText}>Mere info</span><RightArrowSvg /></span>;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t4 || $[17] !== t6 || $[18] !== t9) {
    t11 = <li className={styles.cinemaItem}>{t4}{t6}{t9}{t10}</li>;
    $[16] = t4;
    $[17] = t6;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
}